import { render, staticRenderFns } from "./CampaignMessage.vue?vue&type=template&id=162a8ff6&scoped=true&"
import script from "./CampaignMessage.vue?vue&type=script&lang=js&"
export * from "./CampaignMessage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMessage.vue?vue&type=style&index=0&id=162a8ff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a8ff6",
  null
  
)

export default component.exports